import { motion } from "framer-motion";

export function Example() {
  return (
    <motion.div
      style={{
        width: 150,
        height: 150,
        borderRadius: 30,
        backgroundColor: "#fff",
        cursor: "grab"
      }}
      drag
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.7, transition: { duration: 1 } }}
      whileHover={{ opacity: 1 }}
      whileTap={{
        opacity: 1,
        scale: 1.05,
        boxShadow: "0px 5px 8px #307",
        cursor: "grabbing"
      }}
      whileDrag={{ scale: 1.1, boxShadow: "0px 10px 16px #307" }}
      transition={{ duration: 0.6 }}
    />
  );
}
